<div id="customer-eligibility-completion">
  <div id="eligibility-completion">
    <div class="row">
      <div class="col-md-12 image" id="img">
        <img src="assets/images/veterans_96.png" alt="Star">
      </div>
      <div class="col-md-12 eligibility-completion-exclamation">
        <h2>{{cfetLabels.cfet_customer_eligibility.eligibility_completion}}</h2>
      </div>
    </div>
    <div class="org-card">
      <p class="eligibility-text">
        {{cfetLabels.cfet_customer_eligibility.eligibility_completion_info}}
      </p>

      <p class="org-role">
        <strong>{{selectedCategory}}: {{selectedRole}}</strong>
      </p>

      <p class="org-name">
        {{stateAndZip?.org_name}}
      </p>

      <p class="org-address">
        {{stateAndZip?.address}},
        {{stateAndZip?.city}},
        {{stateAndZip?.state}}
        {{stateAndZip?.zipcode}}
      </p>

    </div>
  </div>
  <div id="verify-section">
      <app-utf-registration-verify-form></app-utf-registration-verify-form>
  </div>
</div>